import React from 'react';
import { MessagePlugin } from 'tdesign-react';
import { MESSAGE_DURATION, DEFAULT_MESSAGES } from '../const/constants.js';

/**
 * 显示错误消息
 * @param {string} message - 错误消息内容
 * @param {string} defaultMsg - 默认消息，默认为 '识别失败'
 */
export const showErrorMessage = (message, defaultMsg = DEFAULT_MESSAGES.RECOGNIZE_FAILED) => {
  MessagePlugin.error({
    content: message || defaultMsg,
    duration: MESSAGE_DURATION,
    className: 'ocrDemo-message-error',
    icon: <span className="ocrDemo-icon-errorMsg"></span>
  });
};

/**
 * 显示成功消息
 * @param {string} message - 成功消息内容
 */
export const showSuccessMessage = (message) => {
  MessagePlugin.success({
    content: message,
    duration: MESSAGE_DURATION
  });
};
